import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-select-new-doc-type',
  templateUrl: './select-new-doc-type.component.html',
  styleUrls: ['./select-new-doc-type.component.css']
})
export class SelectNewDocTypeComponent implements OnInit {
    argType;

    argValue;

    public itemsListDocumentTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadDocumentTypes() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListDocumentTypes = await this.datatask.Post(317, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadDocumentTypes();
    }

    ngOnInit() {
        this.init();
    }
}
